import { render, staticRenderFns } from "./MobilePayRedirect.vue?vue&type=template&id=a639ec50&scoped=true"
import script from "./MobilePayRedirect.vue?vue&type=script&lang=js"
export * from "./MobilePayRedirect.vue?vue&type=script&lang=js"
import style0 from "./MobilePayRedirect.vue?vue&type=style&index=0&id=a639ec50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a639ec50",
  null
  
)

export default component.exports